<div class="wrapper">
  <div class="container d-flex flex-column align-items-center gap-3">
    <div class="title">{{ config.title }}</div>
    <div class="description">{{ config.description }}</div>
    <div *ngIf="config.buttonText" class="mt-2">
      <app-button [type]="ButtonTypeEnum.primary" (buttonClick)="buttonClicked.emit()">{{
        config.buttonText
      }}</app-button>
    </div>
  </div>
</div>
